<template>
  <div>
    <v-dialog v-model="changePicDialog" width="400" persistent>
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <EditPicture @stepper="winStepper" />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md11 lg12 xl10 pt-4 pt-xl-12 px-2>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-card tile flat>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span
                    style="
                      font-family: ibmbold;
                      font-size: 24px;
                      color: #464646;
                    "
                  >
                    My Account
                  </span>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 xl6 text-left>
                  <span
                    style="
                      font-family: ibmbold;
                      font-size: 24px;
                      color: #464646;
                    "
                  >
                    Profile
                  </span>
                </v-flex>
                <v-flex xs12 md6 lg6 xl6 text-center hidden-sm-and-down>
                  <v-btn
                    width="200px"
                    color="#000000"
                    dark
                    :ripple="false"
                    class="text-none"
                    depressed
                    outlined
                    @click="appLogout"
                  >
                    <span
                      style="
                        font-family: ibmbold;
                        font-size: 16px;
                        text-transform: none;
                      "
                    >
                      LOG OUT
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center pt-4 fill-height>
                <v-flex xs6 sm2 md2 lg2 xl2 text-center text-lg-left>
                  <v-img
                    :src="mediaURL + appUser.image"
                    height="180px"
                    width="180px"
                    cover
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#3EA56E"
                        ></v-progress-circular>
                      </v-row>
                    </template>

                    <v-layout
                      wrap
                      fill-height
                      v-if="$route.path == '/Profile/Edit'"
                    >
                      <v-flex align-self-end pb-1 pr-1 text-right>
                        <v-icon
                          style="cursor: pointer"
                          color="#3EA56E"
                          @click="changePicDialog = !changePicDialog"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-img>
                </v-flex>
                <v-flex xs12 sm6 md10 lg10 xl10 text-left px-6 px-xl-0>
                  <v-layout wrap justify-center fill-height>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: ibmmedium;
                          font-size: 16px;
                          color: #000000;
                        "
                      >
                        {{ appUser.firstname }}&nbsp;
                        {{ appUser.lastname }} </span
                      ><br />
                      <span
                        style="
                          font-family: ibmregular;
                          font-size: 16px;
                          color: #000000;
                        "
                      >
                        {{ appUser.email }}
                      </span>
                    </v-flex>
                    <v-flex
                      xs12
                      pt-2
                      pt-lg-0
                      text-center
                      text-sm-left
                      text-md-left
                      text-lg-left
                      align-self-end
                    >
                      <v-btn
                        width="200px"
                        outlined
                        tile
                        color="#757575"
                        dark
                        :ripple="false"
                        depressed
                        to="/Profile/Edit"
                      >
                        <span
                          style="
                            font-family: kumbhsansregular;
                            font-size: 16px;
                            text-transform: none;
                            color: #000000;
                          "
                        >
                          Edit Profile
                        </span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex lg4 pr-4 text-center align-self-center py-4 py-sm0>
                  <v-btn
                    v-if="promocode.code"
                    outlined
                    height="120px"
                    color="#3EA56E"
                    tile
                  >
                    <v-layout wrap>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: ibmregular;
                            font-size: 14px;
                            text-transform: none;
                          "
                          >Get up to
                          <span style="font-family: ibmbold; font-size: 27px"
                            >{{ promocode.discountPercentage }}%</span
                          >
                          off on first purchase</span
                        >
                      </v-flex>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: ibmregular;
                            font-size: 14px;
                            text-transform: none;
                          "
                          >Use the Promo Code</span
                        >
                      </v-flex>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: ibmbold;
                            font-size: 27px;
                            text-transform: none;
                          "
                          >{{ promocode.code }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex pt-2 md12 pr-4>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <!-- Bottom Section -->
        <v-layout wrap justify-start>
          <v-flex xs12 hidden-md-and-up>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <span
                    style="
                      font-family: ibmmedium;
                      font-size: 18px;
                      color: #545353;
                    "
                    >{{ $route.name }}</span
                  >
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mx-auto" max-width="500" tile flat>
                    <v-list>
                      <template v-for="(item, i) in navItems">
                        <v-list-item :key="item.name" link :to="item.route">
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-layout wrap justify-center py-4>
                                <v-flex xs12 text-uppercase>
                                  <span
                                    style="
                                      font-family: ibmlight;
                                      font-size: 18px;
                                      color: #545353;
                                      letter-spacing: 1px;
                                    "
                                    >{{ item.name }}</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="i"></v-divider>
                      </template>
                    </v-list>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <!-- Desktop Nav -->
          <v-flex xs2 sm2 md3 lg3 xl2 hidden-sm-and-down>
            <v-layout wrap justify-start>
              <v-flex xs11>
                <v-card class="mx-auto" max-width="500" tile flat>
                  <v-list>
                    <template v-for="(item, i) in navItems">
                      <v-list-item :key="item.name">
                        <v-list-item-title>
                          <router-link :to="item.route">
                            <v-layout wrap justify-center>
                              <v-flex xs12 text-uppercase>
                                <span
                                  :style="
                                    $route.path == item.route
                                      ? {
                                          'font-family': 'ibmsemibold',
                                          color: '#3EA56E',
                                        }
                                      : {
                                          'font-family': 'ibmlight',
                                          color: '#545353',
                                        }
                                  "
                                  style="font-size: 18px; letter-spacing: 1px"
                                  >{{ item.name }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider :key="i"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-flex>
              <v-flex xs1>
                <v-divider vertical></v-divider>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md9 lg9 xl10>
            <v-layout wrap justify-start>
              <!-- <v-divider vertical></v-divider> -->
              <v-flex xs12 sm12 md12>
                <router-view></router-view>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import EditPicture from "./editPicture";
export default {
  components: {
    EditPicture,
  },
  data() {
    return {
      changePicDialog: false,
      // model: 0,
      navItems: [
        { name: "Profile", route: "/Profile" },
        { name: "Orders", route: "/Profile/Orders" },
        { name: "Wishlist", route: "/Profile/Wishlist" },
        { name: "Cart", route: "/Profile/Cart" },
        { name: "Saved Address", route: "/Profile/SavedAddress" },
        { name: "Coupons", route: "/Profile/SavedAddress" },
      ],
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    promocode() {
      return this.$store.state.coupen;
    },
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    winStepper(windowData) {
      if (windowData.ref == "close") {
        this.changePicDialog = windowData.changePicDialog;
      }
    },
  },
};
</script>